import { getInfographUri } from 'utils/getInfographUri';
import { E1_ICON_ID_TO_LINE_ICON_TYPE_MAP } from 'widgets/Lines/LineIconWidget/LineIconWidget.config';

const BASE_ICONS8_URL = '/infographics/icons8_download/';
const BASE_ICONS8_ILLUSTRATIONS_URL = '/infographics/icons8_illustration_download/';

const loadIcons8Icon = async (iconId: string) => {
  try {
    const data = await fetch(getInfographUri(`${BASE_ICONS8_URL}${iconId}`)).then((res) => res.json());

    if (data && data.icon) {
      return data;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};

const loadIcons8Illustration = async (iconId: string) => {
  try {
    const data = await fetch(getInfographUri(`${BASE_ICONS8_ILLUSTRATIONS_URL}${iconId}`)).then((res) => res.text());
    if (data) {
      return data;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};

/**
 * Helper to determine if the icon id returned from search corresponds to a
 * non Icon widget type.
 * For now, only for LineIconWidgets - later may need to add basic shapes
 *
 * @param iconId icon id
 * @returns TRUE if the specified icon id should be treated as a widget other than Icon
 */
const checkIsNonIconWidgetType = (iconId: string) => {
  return !!E1_ICON_ID_TO_LINE_ICON_TYPE_MAP[iconId];
};

export { loadIcons8Icon, loadIcons8Illustration, checkIsNonIconWidgetType };
